// src/pages/dashboard/hooks/useDashboardData.js

import { useCallback, useEffect, useState } from 'react';
import { getDashboardStock } from '../../../../services/rapportService';

export default function useDashboardData() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState({
        date_debut: null,
        date_fin: null,
        marque_id: null,
        taille_id: null
    });

    const fetchData = useCallback(async (params = {}) => {
        setLoading(true);
        try {
            const response = await getDashboardStock(params);
            setData(response.data.data);
            setFilters(params);
            return response.data;
        } catch (error) {
            console.error('❌ Erreur fetchDashboard:', error);
            setData(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return {
        data,
        loading,
        filters,
        fetchData,
        refresh: fetchData
    };
}